import React from 'react'
//@ts-ignore
import logout from '../../assets/images/logout2.png';
const LogoutIcon = () => {
  return (
    <img src={logout} alt="dashboard" height="20" />
  )
}

export default LogoutIcon